/*
 * Use naming convention of <item>_<condition>
 */
export const API_ERROR_MESSAGES = {
  AGENT_AGENCY_CODES_NOT_FOUND: 'Agent agency codes not found', // funnels up to systemError user notification
  AGENCY_NOT_PILOT_ELIGIBLE: 'Agency not pilot eligible',
  AGENT_AGENCY_MISMATCH: 'Agent agency mismatch',
  AGENT_NOT_FOUND: 'Agent not found', // funnels up to systemError user notification
  AXIOM_NOT_ELIGIBLE: 'Axiom not eligible',
  BODY_INVALID: 'Body invalid', // funnels up to systemError user notification
  ECIF_NOT_FOUND: 'ECIF not found',
  EMAIL_NOT_ALLOWED: 'Email not allowed', // funnels up to systemError user notification
  INPUT_FORMAT_INVALID: 'Input format invalid', // funnels up to systemError user notification
  PATH_PARAMETER_MISSING: 'Path parameter missing', // funnels up to systemError user notification
  POLICY_NOT_ACTIVE: 'Policy not active',
  POLICY_NOT_FOUND: 'Policy not found',
  SUBMISSION_NOT_ACTIVE: 'Submission not active',
  SUBMISSION_NOT_FOUND: 'Submission not found',
  USER_NOT_AUTHENTICATED: 'User not authenticated', // funnels up to systemError user notification
} as const;

export type ApiErrorMessage = (typeof API_ERROR_MESSAGES)[keyof typeof API_ERROR_MESSAGES];
